import type { Prototype } from "../prototype-types";

export const sagarPatelPrototypes: Prototype[] = [
  {
    id: "fbf-fbb-order-flip-dropdown",
    name: "FbF to FbB Order Flip Dropdown",
    path: "/sp/fbf-fbb-order-flip-dropdown",
    description:
      "Variant of the FbF→FbB order flip flow using a Slate modal, Select for move reasons (with detail capture for “Something else”), Slate footer actions, and the same payout impact summary.",
    owner: "Sagar",
    createdAt: "2026-05-19",
    lastUpdated: "2026-05-19",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/671288065a6bcce596d08e701e8585fa5584e7a49cf69f86d640ff83b62df146.png",
    creationTool: "cursor",
  },
  {
    id: "fbf-fbb-order-flip-selector",
    name: "FbF to FbB Order Flip Selector",
    path: "/sp/fbf-fbb-order-flip-selector",
    description:
      "Variant of the FbF→FbB order flip flow using a Slate modal with CheckboxGroup multi-select for move reasons, compact yellow payout impact, and the same success and loading states as the dropdown prototype.",
    owner: "Sagar",
    createdAt: "2026-05-19",
    lastUpdated: "2026-05-19",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/671288065a6bcce596d08e701e8585fa5584e7a49cf69f86d640ff83b62df146.png",
    creationTool: "cursor",
  },
  {
    id: "sp-new-to-faire-source-filter",
    name: "New to Faire Source Filter",
    path: "/sp/new-to-faire-source-filter",
    description:
      "New to Faire Source filter pill on the FS shop page — compare Slate default vs Insider-style branded states.",
    owner: "Sagar Patel",
    createdAt: "2026-07-09",
    lastUpdated: "2026-07-09",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/654aa4cbe68cfeee7a0b028257bfa3f7032e235ba2eaa19430ee65e2fe9fe8c2.png",
    creationTool: "cursor",
  },
  {
    id: "sp-brand-orders-action-required",
    name: "Brand Orders Action Required",
    path: "/sp/brand-orders-action-required",
    description:
      "Orders list showing Action Required instead of New/Preparing when FBF auto-accept is blocked by warehouse OOS",
    owner: "Sagar Patel",
    createdAt: "2026-07-31",
    lastUpdated: "2026-07-31",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/a72f6f73a70c9bd004477b322531be4e829970c049bd91b4f56c5858ecf87c8b.png",
    creationTool: "cursor",
    project: "FBF Order manual action transparency",
  },
  {
    id: "sp-faire-source-downfunnel",
    name: "FS Top Up Recommender",
    path: "/sp/faire-source-downfunnel",
    description:
      "Faire Source cart top-up recommender: Psst edge-tag vs progress-bar link entry points into a shared minimum-help modal with product recs.",
    owner: "Sagar Patel",
    createdAt: "2026-09-10",
    lastUpdated: "2026-09-10",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/sp-faire-source-downfunnel.png",
    creationTool: "cursor",
    project: "FS top up recommender",
    figmaLink:
      "https://www.figma.com/design/GwtrzIyly2zK1Yl2FAFi1I/%F0%9F%94%91-Faire-Source--Expanded-Audience?node-id=10028-90066",
  },
];
